module.exports = __webpack_public_path__ + "static/media/PeakHealth_LOGO-HORZ.95184e15.jpg";